<div class="login-container">
  <loading *ngIf="isLoading"></loading>
  <h2 *ngIf="!withNewEmail" class="login-container__title">Log In</h2>
  <h2 *ngIf="withNewEmail" class="login-container__title">Log In With New Email</h2>
  <hr class="login-container__divider" />
  <div class="login-container__body">
    <div class="login-container__input input-label-container">
      <basic-text-input
        #loginEmail
        [propertyName]="'email'"
        [placeholder]="'Email'"
        (valueChanged)="validate()"
      ></basic-text-input>
    </div>
    <div class="login-container__input">
      <dynamic-validation
        #loginPassword
        [requirementProfile]="'default'"
        [propertyName]="'password'"
        [placeholder]="'Password'"
        [inputType]="'password'"
        (valueChanged)="validate()"
      ></dynamic-validation>
    </div>

    <div *ngIf="errorMessage" class="login-container__error">{{ errorMessage }}</div>
    <button
      class="button button--yellow button--primary login-container__button"
      role="button"
      (click)="login()"
      [ngClass]="{ 'button--disabled': buttonDisabled }"
    >
      Submit
    </button>
    <p *ngIf="showRegisterLink()" class="login-container__link-container">
      <span class="login-container__link login-container__link--underlined" role="button" (click)="goToRegister()">
        Don't have an account? Sign up
      </span>
    </p>
    <p class="login-container__link-container">
      <span class="login-container__link login-container__link--underlined" role="button" (click)="goToReset()">
        Forgot password
      </span>
    </p>
  </div>
</div>
